import script from "./testimonials.vue?vue&type=script&lang=ts&setup=true"
export * from "./testimonials.vue?vue&type=script&lang=ts&setup=true"

import "./testimonials.vue?vue&type=style&index=0&id=3cf01061&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cf01061"]])

export default __exports__